export const suiteName = (sr, from) => {
  if( sr.requestType === "Grouping" ) {
    if(from === "CommonArea") {
      return sr.commonAreaName;
    }

    if( sr.suiteName ) {
      return sr.suiteName + (sr.stratalot ? " | " + sr.stratalot : "");
    }

    return sr.ticketNumber;
  }
  
  if(from === "CommonArea") {
    return sr.commonAreaName;
  }

  if( sr.suiteName ) {
    return sr.suiteName + (sr.stratalot ? " | " + sr.stratalot : "");
  }

  return "Common Area";
}


export const commonAreaName = (sr) => {
  if(sr.commonAreaName) return sr.commonAreaName;
  if(sr.area && sr.area.name) return sr.area.name;
  return "";
}

export const sortableType = (sr) => {
  if(sr.requestType === "Grouping") return 0;
  if(sr.requestType === "CommonArea") return "Common";
  if(sr.requestType === null) return "Warranty";
  return sr.requestType;
}